import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=080c34fc&scoped=true"
import script from "./Qrcode.vue?vue&type=script&setup=true&lang=js"
export * from "./Qrcode.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c34fc",
  null
  
)

export default component.exports